import { useState, useEffect } from 'react';
import { getQueueCounts } from './queueCounts';
import { isEffectivelyOnline, subscribeConnectivity } from './connectivity';

export function useOnlineStatus() {
  // `isEffectivelyOnline`, lo mismo que manda la suscripción: con `isOnlineNow`
  // el banner arrancaba «con red» aunque ya se supiera que no hay servidor
  // (spec 2026-10-09).
  const [isOnline, setIsOnline] = useState(isEffectivelyOnline);
  const [pendingCount, setPendingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [foreignCount, setForeignCount] = useState(0);

  useEffect(() => {
    // `pendingCount` = REINTENTABLES: mutations + compound + imágenes no-failed.
    // Se sincronizan solos al reconectar (auto-sync). `failedCount` = imágenes
    // en error TERMINAL (poison pill): NO se auto-sincronizan — requieren el
    // botón "Reintentar" (que resetea su retryCount). Antes se sumaba TODO,
    // así que un upload `failed` inflaba el contador de "pendientes" para
    // siempre (el auto-sync lo saltaba y nunca bajaba a 0).
    const updateCounts = async () => {
      // Propio y ajeno según la sesión ACTUAL (spec 2026-10-01 § 6.3).
      const counts = await getQueueCounts();
      setPendingCount(counts.pending);
      setFailedCount(counts.failed);
      setForeignCount(counts.foreign);
    };

    updateCounts();

    const handleQueueChange = () => updateCounts();

    window.addEventListener('offline-queue-changed', handleQueueChange);
    // Al entrar otro usuario, lo que era pendiente pasa a ser ajeno y al revés.
    window.addEventListener('session-changed', handleQueueChange);

    // App nativa: el ConnectivityManager de Android como fuente PRINCIPAL. El
    // evento del WebView llega tarde o no llega al salir de un túnel o al
    // pasar de avión a datos, que es justo cuando el operario espera que su
    // trabajo pendiente suba solo. Se conservan ambos: si cualquiera de los
    // dos dice que hemos vuelto, se intenta. En web esto no engancha nada.
    const unsubscribeConnectivity = subscribeConnectivity(setIsOnline);
    // Lo que cambiara entre el render y la suscripción no llega por el aviso:
    // el cortacircuitos puede abrir a los ~300 ms de arrancar con el servidor
    // caído, antes de que el banner se monte.
    setIsOnline(isEffectivelyOnline());

    return () => {
      unsubscribeConnectivity();
      window.removeEventListener('offline-queue-changed', handleQueueChange);
      window.removeEventListener('session-changed', handleQueueChange);
    };
  }, []);

  return { isOnline, pendingCount, failedCount, foreignCount };
}
